import { DEM_ATTRIBUTION, DEM_ENCODING, DEM_TILES_URL } from '@/features/elevation';
import type { StylePart } from '@/features/map';

export const TERRAIN_SOURCE = 'dem';

export const terrainStyle = (): StylePart => ({
  sources: {
    [TERRAIN_SOURCE]: {
      type: 'raster-dem',
      tiles: [DEM_TILES_URL],
      encoding: DEM_ENCODING,
      tileSize: 256,
      maxzoom: 15,
      attribution: DEM_ATTRIBUTION,
    },
  },
});
